import { SideStatisticsItem, Text } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateSideStatisticsItemModel } from './C51SideStatisticsItem.service';
import { C51SideStatisticsItemProps } from './C51SideStatisticsItem.types';
import { PropsWithChildren, ReactNode } from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

/** The component-library component for this rendering does not display in a way that makes editing in Experience Editor feasible.
 * So `EditHeroStatisticsItem` is a custom component that displays the fields with minimal styles.
 */
const EditSideStatisticsItem = (
  props?: PropsWithChildren & { fields: Array<{ label: string; field: ReactNode }> }
) => {
  return (
    <li style={{ display: 'grid', gridColumn: 'span 3', gap: '0.5rem', padding: '0.5rem' }}>
      {props?.fields.map((f, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text tag="span" style={{ textAlign: 'left' }}>
            <b>{f.label}</b>
          </Text>
          <Text tag="span" style={{ textAlign: 'right' }}>
            {f.field}
          </Text>
        </div>
      ))}
    </li>
  );
};

export default function C51SiteStatisticsItem(props?: C51SideStatisticsItemProps) {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = CreateSideStatisticsItemModel(props);

  if (isEditing) {
    return (
      <EditSideStatisticsItem
        fields={[
          { label: 'Prefix', field: model.prefix },
          { label: 'Statistic', field: model.statistic },
          { label: 'Suffix', field: model.suffix },
          { label: 'Support copy', field: model.supportCopy },
        ]}
      />
    );
  }

  return (
    <SideStatisticsItem
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
}
